<script setup>
import { ref } from 'vue'

const selectedIndex = ref(-1)

const handleToggle = (index) => {
  selectedIndex.value = selectedIndex.value === index ? -1 : index
}
</script>

<template>
  <div class="pricing-page__faq">
    <div class="pricing-page__section-header">
      <h3>{{ $t('Frequently asked Questions') }}</h3>
    </div>

    <div class="pricing-page__accordions">
      <div v-for="(faq, faqIndex) in Object.values($tm('faqs'))" :key="`q${faqIndex}`" class="accordion">
        <div @click="handleToggle(faqIndex)" class="accordion__title-wrapper">
          <h5 class="accordion__title link-16">{{ $rt(faq.question) }}</h5>
          <div class="accordion__toggle-wrapper">
            <div :class="{ active: selectedIndex === faqIndex }" class="accordion__toggle"></div>
          </div>
        </div>
        <div :class="{ open: selectedIndex === faqIndex }" class="accordion__content">
          <ul>
            <li v-for="(answer, answerIndex) in Object.values(faq.answers)" :key="`q${faqIndex}a${answerIndex}`">
              <p class="basic-14" v-html="$rt(answer)"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
